import authApi from '@/api/auth'
import {
  getUserAddress,
  updateUserPaymentExtraDetails,
  updateUserAddress,
  updateUser,
  updateUserAvatar
} from '@/api/user.api'

const state = {
  token: authApi.getToken(),
  isLogged: null,
  user: {},
  userAddress: {
    zipcode: '',
    street: '',
    street_number: '',
    state: '',
    city: '',
    neighborhood: '',
    phone_number: '',
  },
}

const mutations = {
  setUser (state, user) {
    state.user = user
  },
  setToken (state, token) {
    state.token = token
  },
  setLogged (state, status) {
    state.isLogged = status
  },
  setUserAddress (state, address) {
    state.userAddress = address
  },
  setUserAsPersonalInfosFilled (state) {
    state.user.is_personal_infos_filled = true
  },
  setUserTrail (state, trailId) {
    state.user.settings.current_trail = trailId
  }
}

const actions = {
  async updateUserAvatar ({ getters }, file) {
    try {
      const user = await updateUserAvatar('me', file)

      getters.user.avatar = user.avatar

      return { success: true, user }
    } catch (err) {
      return { success: false, error: err.data.errors.join(', ') }
    }
  },

  async updateUser ({ commit }, data) {
    try {
      const response = await updateUser('me', data)

      commit('setUser', response.data)
      return { success: true, user: response.data }
    } catch (err) {
      return { success: false, errors: err.data.errors }
    }
  },

  async updateUserPaymentExtraDetails ({ commit }, data) {
    const details = await updateUserPaymentExtraDetails(data)

    commit('setUser', details.user)
    commit('setUserAddress', details.address)
  },
  async fetchUser ({ commit }) {
    const user = await authApi.getUserByToken()
    commit('setUser', user)
    return user
  },

  async getUserAddress ({ commit }, userId = 'me') {
    const userAddress = await getUserAddress(userId)
    if (userAddress) {
      commit('setUserAddress', userAddress)
    }
    return userAddress
  },

  async updateUserAddress (context, data) {
    await updateUserAddress(data)
  }
}

const getters = {
  user (state) {
    return state.user
  },

  hasUserSubscriptionAccess ({ user }) {
    return user && user.has_subscription_access
  },

  isLogged (state) {
    return (state.isLogged == null) ? !!state.token : state.isLogged
  },

  userAddress (state) {
    return state.userAddress
  },

  token (state) {
    return state.token
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
